module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/promo/8-79b6e3a9663035b217386f9deb2b28a2.png";